export type TimeType = 'permanent' | 'temporary';
export type SkipType = 'skip' | 'no_skip' | 'default';
export type RepeatIntervalType = 'daily' | 'weekly' | 'advanced';
export const MIN_DATE = '2000-01-01';
export const MAX_DATE = '2100-01-01';
export const TIME_TYPE_OPTIONS: {
  value: TimeType;
  label: string;
}[] = [
  {
    value: 'permanent',
    label: 'Permanent',
  },
  {
    value: 'temporary',
    label: 'Temporary',
  },
];

export const SKIP_TYPE_OPTIONS: {
  value: SkipType;
  label: string;
}[] = [
  {
    value: 'default',
    label: 'Default Skip Count',
  },
  {
    value: 'no_skip',
    label: 'Send Every Position',
  },
  {
    value: 'skip',
    label: 'Count',
  },
];

export const REPEAT_INTERVAL_TYPE_OPTION: {
  value: RepeatIntervalType;
  label: string;
}[] = [
  {
    value: 'daily',
    label: 'Daily',
  },
  {
    value: 'weekly',
    label: 'Weekly',
  },
  {
    value: 'advanced',
    label: 'Custom',
  },
];
